"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _validators = require("../validators");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var MultiselectContainer = (0, _styles.styled)(_material.Grid)(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    flexWrap: 'wrap'
  };
});
var MultiselectChip = (0, _styles.styled)(_material.Chip)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    margin: 2
  };
});
function AnyMultiselect(_ref3) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'outlined' : _ref3$variant,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'small' : _ref3$size,
    _ref3$margin = _ref3.margin,
    margin = _ref3$margin === void 0 ? 'dense' : _ref3$margin,
    _ref3$fullWidth = _ref3.fullWidth,
    fullWidth = _ref3$fullWidth === void 0 ? true : _ref3$fullWidth,
    name = _ref3.name,
    initialValue = _ref3.initialValue,
    label = _ref3.label,
    options = _ref3.options,
    required = _ref3.required,
    disabled = _ref3.disabled,
    fixed = _ref3.fixed,
    _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'primary' : _ref3$color,
    register = _ref3.register,
    notifier = _ref3.notifier;
  var _useState = (0, _react.useState)(function () {
      var defaultValues = initialValue !== null && initialValue !== void 0 ? initialValue : [];
      if (!fixed) {
        return defaultValues;
      }
      var missing = defaultValues.filter(function (el) {
        return fixed.indexOf(el) >= 0;
      });
      return [].concat(_toConsumableArray(fixed), _toConsumableArray(missing));
    }),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    blured = _useState4[0],
    setBlured = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    valid = _useState6[0],
    setValid = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    dirty = _useState8[0],
    setDirty = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var ref = (0, _react.useRef)({
    valid: valid,
    dirty: dirty,
    value: value,
    setBlur: function setBlur() {
      return setBlured(true);
    }
  });
  var handleChange = (0, _react.useCallback)(function (event, child) {
    var value = event.target.value || [];
    setValue(value);
    setDirty(true);
  }, []);
  var onBlur = (0, _react.useCallback)(function (event) {
    setBlured(dirty);
  }, [dirty]);
  var onClose = (0, _react.useCallback)(function () {
    setBlured(dirty); // solo se marca como blured si ya fue modificado algún valor
  }, [dirty]);
  var onNotify = (0, _react.useCallback)(function (value) {
    if (notifier) {
      notifier(name, value);
    }
  }, [notifier, name]);
  (0, _react.useEffect)(function () {
    var valid = !required || value.length > 0;
    var error = valid ? undefined : _validators.TEXT_REQUIRED_VALIDATOR.getMessage();
    ref.current.valid = valid;
    ref.current.dirty = dirty;
    ref.current.value = value;
    setValid(valid);
    setError(error);
    onNotify(value);
  }, [value, dirty, required, onNotify]);
  (0, _react.useEffect)(function () {
    register(name, ref.current);
  }, [register, name, ref]);
  (0, _react.useEffect)(function () {
    var allowed = options.map(function (el) {
      return el.value;
    });
    var initial = initialValue !== null && initialValue !== void 0 ? initialValue : [];
    if (disabled && initial.length === 0) {
      setValue([]);
    } else {
      var _value = initial.filter(function (el) {
        return allowed.indexOf(el) >= 0;
      });
      if (fixed) {
        var missing = fixed.filter(function (el) {
          return _value.indexOf(el) < 0;
        });
        setValue([].concat(_toConsumableArray(_value), _toConsumableArray(missing)));
      } else {
        setValue(_value);
      }
    }
  }, [initialValue, options, fixed, disabled]);
  return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
    variant: variant,
    margin: margin,
    size: size,
    required: required,
    fullWidth: fullWidth,
    error: blured && !valid
  }, /*#__PURE__*/_react["default"].createElement(_material.InputLabel, {
    htmlFor: "multiselect-chip-".concat(name)
  }, label), /*#__PURE__*/_react["default"].createElement(_material.Select, {
    label: label,
    value: value,
    multiple: true,
    onChange: handleChange,
    onClose: onClose,
    onBlur: onBlur,
    required: required,
    disabled: disabled,
    inputProps: {
      id: "multiselect-chip-".concat(name),
      name: name
    },
    renderValue: function renderValue(selected) {
      return /*#__PURE__*/_react["default"].createElement(MultiselectContainer, null, selected.map(function (value) {
        var el = options.find(function (el) {
          return el.value === value;
        });
        return /*#__PURE__*/_react["default"].createElement(MultiselectChip, {
          key: value,
          label: (el === null || el === void 0 ? void 0 : el.label) || value,
          color: disabled ? 'default' : color
        });
      }));
    }
  }, options.map(function (el) {
    var selected = (value === null || value === void 0 ? void 0 : value.indexOf(el.value)) >= 0;
    var disabled = !!fixed && fixed.indexOf(el.value) >= 0;
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: el.value,
      value: el.value,
      selected: selected,
      disabled: disabled,
      dense: true,
      sx: {
        py: 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      size: "small",
      color: color,
      checked: selected
    }), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
      primary: el.label
    }));
  })), blured && !valid && /*#__PURE__*/_react["default"].createElement(_material.FormHelperText, null, error));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AnyMultiselect);